export default __webpack_public_path__ + "df49c71.png";